// 导出页面为PDF格式
import html2Canvas from 'html2canvas'
import JsPDF from 'jspdf'
import store from '../store'

export default{
  install (Vue, options) {
    Vue.prototype.getPdf = function () {
      var title = this.htmlTitle;
      html2Canvas(document.querySelector('#pdfdom'), {
        allowTaint:false,
        useCORS: true, // 是否尝试使用CORS从服务器加载图像
        async: false, // 是否异步解析和呈现元素
        dpi: 192, // 将分辨率提高到特定的dpi,默认值为96
        scale: this.scale?this.scale:1, // 用于渲染的比例尺。默认为浏览器设备像素比率。默认值是1，手机端设置成2
      }).then(function (canvas) {
        var isEnd = false;
        var leftHeight = canvas.height
        var a4Width = 595.28
        var a4Height = 701.89 //A4大小，210mm x 297mm，四边各保留10mm的边距，显示区域190x277
        //一页pdf显示html页面生成的canvas高度;
        var a4HeightRef = Math.floor((canvas.width / a4Width) * a4Height)

        //pdf页面偏移
        var position = 0

        var pageData = canvas.toDataURL('image/jpeg', 1.0)

        var pdf = new JsPDF('p', 'pt', 'a4') //A4纸，纵向
        var index = 1,
          imgIndex=1,
          canvas1 = document.createElement('canvas'),
          imgCanvas1 = document.createElement('canvas'),
          height
        pdf.setDisplayMode('fullwidth', 'continuous', 'FullScreen')

        
        var top = document.querySelector('.biaotou');
        var pageNum = 1;


        var pdfName = title;
        console.log(pdfName);
        function createImpl(canvas,pageAllNum) {
          console.log('createImpl');
          console.log(canvas);
          console.log(leftHeight, a4HeightRef)
          if (leftHeight > 0) {
            index++

            var checkCount = 0
            if (leftHeight > a4HeightRef) {
              var i = position + a4HeightRef
              for (i = position + a4HeightRef; i >= position; i--) {
                var isWrite = true
                for (var j = 0; j < canvas.width; j++) {
                  var c = canvas.getContext('2d').getImageData(j, i, 1, 1).data

                  if (c[0] != 0xff || c[1] != 0xff || c[2] != 0xff) {
                    isWrite = false
                    break
                  }
                }
                if (isWrite) {
                  checkCount++
                  if (checkCount >= 1) {
                    break
                  }
                } else {
                  checkCount = 0
                }
              }
              height = Math.round(i - position) || Math.min(leftHeight, a4HeightRef)
              if (height <= 0) {
                height = a4HeightRef
              }
            } else {
              height = leftHeight
            }

            canvas1.width = canvas.width
            canvas1.height = height


            var ctx = canvas1.getContext('2d')
            ctx.drawImage(
              canvas,
              0,
              position,
              canvas.width,
              height,
              0,
              0,
              canvas.width,
              height,
            )

            var pageHeight = Math.round((a4Width / canvas.width) * height)
            // pdf.setPageSize(null, pageHeight)
            if (position != 0) {
              pdf.addPage()
            }
            pdf.addImage(
              canvas1.toDataURL('image/jpeg', 1.0),
              'JPEG',
              0,
              80,
              a4Width,
              (a4Width / canvas1.width) * height,
            )
            // 添加顶眉和页码
            pdf.addImage(top, 'PNG', 0, 30,a4Width,(a4Width / top.width) * top.height,);
            var page = null;
            if(document.querySelector('.imgpage'+pageNum)&&leftHeight > a4HeightRef){
              page = document.querySelector('.imgpage'+pageNum);
              pdf.addImage(page, 'PNG', 0, 790,a4Width,(a4Width / page.offsetWidth) * page.offsetHeight,);
            }
            pageNum++;


            leftHeight -= height
            position += height
            if (leftHeight > 0) {
              console.log(canvas);
              setTimeout(createImpl, 500, canvas)
            } else {
                
              pdf.save(pdfName + '.pdf');
              document.querySelector('.dingmeiimg').removeChild(top);
              document.querySelector('.pages').innerHTML='';
              store.dispatch('global/setLoading', false)
            }
          }
        }
       
        //当内容未超过pdf一页显示的范围，无需分页
        if (leftHeight < a4HeightRef) {
          try {
            pdf.deleteJage(0)
            setTimeout(createImpl, 500, canvas)
          } catch (err) {
            console.log(err);
          }
          store.dispatch('global/setLoading', false)
        } else {
          try {
            pdf.deleteJage(0)
            setTimeout(createImpl, 500, canvas)
          } catch (err) {
            console.log(err);
          }
          store.dispatch('global/setLoading', false)

        }
      })

      // html2Canvas(document.querySelector('#content2'), {
      //   allowTaint:false,
      //   useCORS: true, // 是否尝试使用CORS从服务器加载图像
      //   async: false, // 是否异步解析和呈现元素
      //   dpi: 192, // 将分辨率提高到特定的dpi,默认值为96
      //   scale:1, // 用于渲染的比例尺。默认为浏览器设备像素比率。默认值是1，手机端设置成2
      // }).then(function (canvas) {
      // })
    }
  }
}